import client from './client';

export const route53Api = {
  async listZones() {
    const { data } = await client.get('/api/admin/route53');
    return data;
  },

  async listRecords(zoneId) {
    const { data } = await client.get(`/api/admin/route53/${zoneId}/records`);
    return data;
  },

  async createRecord(zoneId, record) {
    const { data } = await client.post(`/api/admin/route53/${zoneId}/records`, record);
    return data;
  },

  async updateRecord(zoneId, record) {
    const { data } = await client.put(`/api/admin/route53/${zoneId}/records`, record);
    return data;
  },

  async deleteRecord(zoneId, record) {
    const { data } = await client.delete(`/api/admin/route53/${zoneId}/records`, { data: record });
    return data;
  },
};
